document.addEventListener('DOMContentLoaded', function() {
  if (!document.querySelector(".blog-page .post-sidebar")) {
    return;
  }

  var fixedSidebar, sidebarParent, offsetTop, offsetLeft;
  
  function setVariables() {
    fixedSidebar = document.querySelector(".blog-page .post-sidebar");
    sidebarParent = fixedSidebar.parentElement;

    offsetTop = sidebarParent.offsetTop - 32;
    offsetLeft = sidebarParent.offsetLeft;
  }

  function updateSidebarPosition() {
    if (window.innerWidth >= 1000) {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var parentBottom = sidebarParent.offsetTop + sidebarParent.offsetHeight;

      var distanceFromBottom = parentBottom - (scrollTop + fixedSidebar.offsetHeight);

      if (scrollTop >= offsetTop) {
        if (distanceFromBottom > 32) {
          fixedSidebar.style.position = "fixed";
          fixedSidebar.style.top = "32px";
          fixedSidebar.style.left = offsetLeft + "px";
          fixedSidebar.style.bottom = "auto";
          fixedSidebar.style.width = sidebarParent.offsetWidth + "px";
        } else {
          fixedSidebar.style.position = "absolute";
          fixedSidebar.style.top = "auto";
          fixedSidebar.style.left = "0";
          fixedSidebar.style.bottom = "0";
          fixedSidebar.style.width = sidebarParent.offsetWidth + "px";
        }
      } else {
        fixedSidebar.style.position = "static";
      }
    } else {
      fixedSidebar.style.position = "static";
      fixedSidebar.style.width = "auto";
      fixedSidebar.style.top = "unset";
      fixedSidebar.style.left = "unset";
      fixedSidebar.style.bottom = "unset";
    }
  }

   window.addEventListener("scroll", updateSidebarPosition);

   window.addEventListener("resize", function() {
    setVariables();
    updateSidebarPosition();
   });

   setVariables();
   updateSidebarPosition();
});